import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    title: string;
}

export const AssPlayerTitleHeaderComponent: React.ForwardRefRenderFunction<any, IProps> = ({ title }, forwardRef) => {

    const theme = useTheme();

    return (
        <Box
            padding={2}
            ref={forwardRef}
            sx={
                (theme) => ({
                    backgroundColor: "#edf0f8",
                    borderRadius: "6px",
                })
            }
        >
            <Grid container justifyContent="center">
                <Grid>
                    <Typography variant="h2" color={theme.palette.muted.dark}>
                        {title}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export const AssPlayerTitleHeader = React.forwardRef(AssPlayerTitleHeaderComponent);
